"use client";

import React, { FC } from "react";

import { ImageCommon } from "~/bff/types/ImageCommon";
import { getTestAutomationProps } from "~/helpers/test-automation-props";
import { Nullable } from "~/types/general.types";

import { HeaderToolbar } from "../header-toolbar/component";

import { SLIDE_MENU_CLASSES } from "./constants";
import { SlideMenuDrawer } from "./styled";

export interface SideMenuProps {
  logo?: Nullable<ImageCommon>;
  isOpen?: boolean;
  onClose?: () => void;
  isSearchOpen?: boolean;
  onSearchOpen?: () => void;
  children?: React.ReactNode;
}

export const SideMenu: FC<SideMenuProps> = ({
  logo,
  isOpen,
  onClose,
  isSearchOpen,
  onSearchOpen,
  children,
}) => {
  return (
    <SlideMenuDrawer
      PaperProps={{
        className: SLIDE_MENU_CLASSES.drawer,
        ...getTestAutomationProps("side-menu"),
      }}
      anchor="left"
      open={isOpen}
      onClose={onClose}
    >
      <HeaderToolbar
        logo={logo}
        isMenuOpen={isOpen}
        onMenuOpen={onClose}
        isSearchOpen={isSearchOpen}
        onSearchOpen={onSearchOpen}
      />
      {children}
    </SlideMenuDrawer>
  );
};
